import VTooltip from 'v-tooltip';
import Vue from 'vue';

const options = {
  // Default tooltip placement relative to target element
  defaultPlacement: 'right',
  // Default CSS classes applied to the tooltip element
  // defaultClass: '',
  defaultClass: 'vue-tooltip-theme',
  // Default CSS classes applied to the target element of the tooltip
  defaultTargetClass: 'has-tooltip',
  // Is the content HTML by default?
  defaultHtml: true,
  // Default HTML template of the tooltip element
  // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
  // Change if the classes conflict with other libraries (for example bootstrap)
  // defaultTemplate: '<div class=" popover2 fade2 right2 in2 tooltip " role="tooltip"><div class="arrow">
  // </div><div class="popover-content" style="max-width: 400px;"></div></div>',
  // defaultTemplate: '<div class=" popover2 fade2 right2 in2 tooltip " role="tooltip"><div class="arrow">
  // </div><h3 class="popover-title">Bla bla</h3><div class="popover-content" style="max-width: 400px;"></div></div>',
  // Selector used to get the arrow element in the tooltip template
  // defaultArrowSelector: '.arrow',
  // Selector used to get the inner content element in the tooltip template
  // defaultInnerSelector: '.popover-content, .popover__content',
  // defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  // // Selector used to get the arrow element in the tooltip template
  defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
  // Selector used to get the inner content element in the tooltip template
  defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
  // Delay (ms)
  defaultDelay: 0,
  // Default events that trigger the tooltip
  defaultTrigger: 'hover',
  // Default position offset (px)
  defaultOffset: 0,
  // Default container where the tooltip will be appended
  defaultContainer: 'body',
  defaultBoundariesElement: undefined,
  defaultPopperOptions: {},
  // Class added when content is loading
  defaultLoadingClass: 'tooltip-loading',
  // Displayed when tooltip content is loading
  defaultLoadingContent: '...',
  // Hide on mouseover tooltip
  autoHide: false,
  // Close tooltip on click on tooltip target?
  defaultHideOnTargetClick: false,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 0,
  // Other options
  popperOptions: {
    // preventOverflow: {
    //   priority: ['right', 'bottom', 'top'],
    // },
  },
  // Options for popover
  popover: {
    defaultPlacement: 'bottom',
    // Use the `popoverClass` prop for theming
    defaultClass: 'vue-popover-theme',
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: 'tooltip popover',
    // Wrapper class (contains arrow and inner)
    defaultWrapperClass: 'wrapper',
    // Inner content class
    defaultInnerClass: 'tooltip-inner popover-inner',
    // Arrow class
    defaultArrowClass: 'tooltip-arrow popover-arrow',
    defaultDelay: 0,
    defaultTrigger: 'click',
    defaultOffset: 0,
    defaultContainer: 'body',
    defaultBoundariesElement: undefined,
    defaultPopperOptions: {},
    // Hides if clicked outside of popover
    defaultAutoHide: true,
    // Update popper on content resize
    defaultHandleResize: true,
  },
};
Vue.use(VTooltip, options);
